import { FC } from 'react';
import { Card, Fx, Icon, OptionalValue } from 'Components';
import { LineProgress, InfoTooltip } from 'Pages/Dashboard/components';
import { getProgressStatus } from 'Pages/Dashboard/Dashboard.helpers';
import { TrendIndicatorDirection } from 'Pages/Dashboard/Dashboard.types';
import { inPercent } from 'Helpers/numeric';
import styles from './StatsCard.module.scss';

export interface StatsCardProps {
	title: string;
	tooltip?: string;
	value?: number | null;
	trend?: number | null;
	trendDirection?: TrendIndicatorDirection | null;
	trendLabel?: string;
	onClick?: () => void;
}

const StatsCard: FC<StatsCardProps> = ({
	title,
	tooltip,
	value,
	trend,
	trendLabel = 'last 30 days',
	onClick
}) => {
	const status = getProgressStatus(value);

	return (
		<Card
			title={
				<Fx align="middle" style={{ gap: 6 }}>
					<span>{title}</span>
					{tooltip && (
						<span className={styles.tooltipIcon}>
							<InfoTooltip title={tooltip} enabled />
						</span>
					)}
				</Fx>
			}
			className={styles.root}
			headStyle={{ border: 'none' }}
			footer={
				<div className={styles.footer}>
					{trend && (
						<div className={styles.trend}>
							<Icon type="plus" className={styles.trend__icon} />
							<OptionalValue>{inPercent(trend)}</OptionalValue>
							&nbsp;{trendLabel}
						</div>
					)}
					<LineProgress percent={value} status={status} />
				</div>
			}
			onClick={onClick}
			hoverable={!!onClick}
		>
			<Fx fullHeight justify="center" column>
				<div className={styles.value}>
					<OptionalValue>{inPercent(value)}</OptionalValue>
				</div>
			</Fx>
		</Card>
	);
};

export default StatsCard;
